import { getWidth } from "../common";

const columns = 12;
export default Array.from({ length: columns }, (_, current) => {
  const field = `rocker_${current + 1}`;
  return {
    field,
    label: field,
    width: getWidth(columns),
    isSortable: false,
    isCSV: true,
  };
});
